export const locationSearch = (name: string) => {
    const paramsPath = window.location.search.substring(1);
    const paramsArr = paramsPath?.split('&');
    let value = '';
    paramsArr?.forEach(param => {
        const key = param.split('=')[0];
        if(key === name) {
            value = param.split('=')[1];
        }
        return value;
    });
    
    return value;
}

const getPathParams = () => {
    const path = window.location.pathname;
    const params = path.split('/');
    return {
        customerId: params[1],
        appName: params[2]
    }

}

export const decodeBase64 = (base64: string): Uint8Array => {
    if (base64 == null) {
        return base64;
    }
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}

export const routerCustomerId = getPathParams().customerId;
export const routerAppName = getPathParams().appName;

